<template>
  <div class="main">
    <div class="list-bg" :style="{backgroundImage:'url('+bkimg+')'}">
    </div>
    <div class="contain">
      <div class="top">
        <div class="left">
          <div class="navigate boderright pointer">
            <div><span :class='{"lastnav":index==navigate.length-1}' v-for='(nav,index) in navigate' :key='index' @click="goto(index)">{{nav}}<span class='lastnav' v-show='index != navigate.length-1'>></span></span></div>
            <!-- <img src="../static/images/b1.jpg" alt=""> -->
          </div>
          <div class="boderright contentt">
            <div class="ctitle">{{lists.title}}</div>
            <div class="counttime">
              <img src="../static/images/eye.jpg" alt="">
              <span>{{lists.visitornum || lists.clickNum}}</span>
              <img src="../static/images/time.jpg" alt="">
              <span>{{lists.publishedtime}}</span>
            </div>
          </div>
          <div class="content">
            <!-- <div class="detail" v-for='(data,index) in lists.datas' :key='index'>
              <img v-if='data.pic' src="../static/images/c1.jpg" alt="">
              <p v-else>{{data.content}}</p>
            </div> -->
            <div class="detaila" v-html='lists.detail'></div>
          </div>
        </div>
        <div class="right">
          <div class="rightcontent">
            <!-- <p class='realte'>相关线路</p>
            <div class="relatecontentt" v-for='(relate,index) in relatelists' :key='index'>
              <img src="../static/images/r1.jpg" alt="">
              <div class="con">
                <p class='title'>{{relate.title}}</p>
                <div class="describe">{{relate.describe}}</div>
                <div class="priceitem">
                  <span class='price'>￥{{relate.price}}</span><span class='count'>{{relate.personcount}}人出游</span>
                </div>
              </div>
            </div> -->
            <!-- <Lists2 :sidelists="plists"></Lists2> -->
          </div>
          <div class="rightcontent">
            <p class='realte'>往期回顾</p>
            <!-- <div class="relatecontentt" v-for='(relate,index) in reviews' :key='index'>
              <img src="../static/images/w1.jpg" alt="">
              <div class="con">
                <p class='title'>{{relate.title}}</p>
                <div class="describe">{{relate.describe}}</div>
                <div class="priceitem">
                  <span class='price'>￥{{relate.price}}</span><span class='count'>{{relate.personcount}}人出游</span>
                </div>
              </div>
            </div> -->
            <Lists2 :sidelists="plists"></Lists2>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="like">
          <p>猜你喜欢</p>
          <div class='change'>
            <span @click='change'>换一批</span>
            <img src="../static/images/change.jpg" alt="">
          </div>
        </div>
        <div class="flex">
          <!-- <div class="likeline" v-for='(like,index) in likes' :key='index'>
            <div class="space">
              {{like.stimulate}} <span class='line'>|</span>{{like.experience}}
            </div>
            <img class='likepic' src="../static/images/one.jpg" alt="">
            <div class="routline">主推路线</div>
            <p class='lines'>{{like.line}}</p>
            <p class='liketitle'>{{like.title}}</p>
            <div class='liketime'>
              <img src="../static/images/time.jpg" alt="">
              <span>出行时间:{{like.startime}}至{{like.endtime}}</span>
            </div>
            <div class="flex">
                <div class="labels" v-for='(label,index) in like.label' :key='index'>
                    {{label}}
                </div>
            </div>
          </div> -->
          <Lists :lists="hotlists"></Lists>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {reviewdetail, reviewlist} from '@/api/past.js'
import {strategydetail} from '@/api/free.js'
import {getNewsListDetail} from '@/api/news.js'
import {getPartnersListDetail} from '@/api/partners.js'
import {formateDateNumber, delEnter, sliceDate} from '@/utils/index.js'
import Lists from '@/components/ListsContent.vue'
import Lists2 from '@/components/ListsContent2.vue'
import {getthemelist} from '@/api/theme.js'
import {querycontent} from '@/api/content.js'
export default {
  components: {
    Lists,
    Lists2
  },
  data () {
    return {
      bkimg: '',
      navigate: ['首页', '极地探险', '往期回顾', '遇见北极秋...'],
      relatelists: [
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        },
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        },
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        },
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        }
      ],
      reviews: [
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        },
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        },
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        },
        {
          picurl: '../static/images/r1.jpg',
          title: '北极路线',
          describe: '南极,这里被人们称为第七大陆南极,这里被人们称为第七大陆',
          price: 12345,
          personcount: 197

        }
      ],
      lists: {
        title: '遇见北极秋色·北极路线格陵兰岛冰岛环游之旅',
        browse: 562,
        time: 3,
        datas: [
          {pic: false, content: '冰岛和格陵兰岛是两个完全不同的国度。冰岛是冰与火，在频繁的火山爆发下，地貌不断改变的国家。然而，格陵兰却更加原始，在那里看到的每一座山都是上几亿年的，浮冰更是上千上万年，大部分因纽特人村落还保持原始的生活方式。身处在格陵兰岛是一种怎样的体验呢？你可以想象一下这样的画面，在闹哄哄的咖啡厅突然戴上一幅隔音效果巨好的耳机是什么感觉？'},
          {pic: true, url: '../static/images/c1.jpg'},
          {pic: false, content: '冰岛和格陵兰岛是两个完全不同的国度。冰岛是冰与火，在频繁的火山爆发下，地貌不断改变的国家。然而，格陵兰却更加原始，在那里看到的每一座山都是上几亿年的，浮冰更是上千上万年，大部分因纽特人村落还保持原始的生活方式。身处在格陵兰岛是一种怎样的体验呢？你可以想象一下这样的画面，在闹哄哄的咖啡厅突然戴上一幅隔音效果巨好的耳机是什么感觉？'},
          {pic: true, url: '../static/images/c1.jpg'},
          {pic: false, content: '冰岛和格陵兰岛是两个完全不同的国度。冰岛是冰与火，在频繁的火山爆发下，地貌不断改变的国家。然而，格陵兰却更加原始，在那里看到的每一座山都是上几亿年的，浮冰更是上千上万年，大部分因纽特人村落还保持原始的生活方式。身处在格陵兰岛是一种怎样的体验呢？你可以想象一下这样的画面，在闹哄哄的咖啡厅突然戴上一幅隔音效果巨好的耳机是什么感觉？'},
          {pic: false, content: '冰岛和格陵兰岛是两个完全不同的国度。冰岛是冰与火，在频繁的火山爆发下，地貌不断改变的国家。然而，格陵兰却更加原始，在那里看到的每一座山都是上几亿年的，浮冰更是上千上万年，大部分因纽特人村落还保持原始的生活方式。身处在格陵兰岛是一种怎样的体验呢？你可以想象一下这样的画面，在闹哄哄的咖啡厅突然戴上一幅隔音效果巨好的耳机是什么感觉？'},
          {pic: true, url: '../static/images/c1.jpg'}
        ]
      },
      likes: [
        {
          picurl: '../static/images/one.jpg',
          title: '跨越半个地球寻觅安第斯山脉的足迹——记录南美初体验',
          startime: '2019-01-01',
          endtime: '2019-02-13',
          stimulate: '特别刺激',
          experience: '完美体验',
          label: ['网红拍摄地点', '企鹅/海豹', '家庭亲子游'],
          line: '[ 极地探险-北极路线 ]'
        },
        {
          picurl: '../static/images/one.jpg',
          title: '跨越半个地球寻觅安第斯山脉的足迹——记录南美初体验',
          startime: '2019-01-01',
          endtime: '2019-02-13',
          stimulate: '特别刺激',
          experience: '完美体验',
          label: ['网红拍摄地点', '企鹅/海豹', '家庭亲子游'],
          line: '[ 极地探险-北极路线 ]'
        },
        {
          picurl: '../static/images/one.jpg',
          title: '跨越半个地球寻觅安第斯山脉的足迹——记录南美初体验',
          startime: '2019-01-01',
          endtime: '2019-02-13',
          stimulate: '特别刺激',
          experience: '完美体验',
          label: ['网红拍摄地点', '企鹅/海豹', '家庭亲子游'],
          line: '[ 极地探险-北极路线 ]'
        }
      ],
      sidelists: [],
      plists: [],
      pquerylist: {
        page: 1,
        limit: 4,
        themeid: undefined,
        ishot: undefined,
        menuId: undefined
      },
      hotlists: [],
      hotquery: {
        page: 1,
        limit: 3,
        ishot: true
      },
      hottotal: 0,
      themes: []
    }
  },
  methods: {
    goto (index) {
      if (index === 0) {
        this.$router.push({path: '/index'})
      } else if (index === 1) {
        this.$router.push({
          path: '/routerLists',
          query: {
            id: 1,
            img: 'https://tripolers.com.cn/admin/storage/fetch/fivqia2r3jovb14m0ihn.jpg',
            name: '极地探险'
          }
        })
      } else if (index === 2) {
        this.$router.push({path: '/pastReview'})
      }
    },
    // 获取自由行宫略
    getfreedetail (id) {
      strategydetail({id}).then(res => {
        this.lists = res.data.data
        this.lists.publishedtime = formateDateNumber(this.lists.publishedtime)
        this.lists.detail = delEnter(this.lists.detail)
      })
    },
    getreviewdetail (id) {
      reviewdetail({id}).then(res => {
        this.lists = res.data.data
        this.lists.publishedtime = formateDateNumber(this.lists.publishedtime)
        this.lists.detail = delEnter(this.lists.detail)
      })
    },
    reviewdetail (id) {
      this.pquerylist.menuId = id
      reviewlist(this.pquerylist).then(res => {
        this.plists = res.data.data.items
      })
    },
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        if (res.data.errno === 0) {
          let themes = res.data.data.items
          themes.forEach(element => {
            this.themes[element.id] = element.tname
          })
          this.gethotlist()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    gethotlist () {
      querycontent(this.hotquery).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
          items[i].classes = this.themes[items[i].themeId]
          items[i].active = false
        }
        items[0].active = true
        this.hotlists = items
        this.hottotal = res.data.data.total
      })
    },
    change () {
      if (this.hottotal <= this.hotquery.page * 3) {
        this.hotquery.page = 1
      } else {
        this.hotquery.page += 1
      }
      this.gethotlist()
    },
    changePage () {
      if (this.$route.params.title) {
        this.navigate[3] = this.$route.params.title.substr(0, 5) + '...'
      } else if (this.$route.query.title) {
        this.navigate[3] = this.$route.query.title.substr(0, 5) + '...'
      }
    },
    // 极之美详情
    getjzmdetail (id) {
      getNewsListDetail({id}).then(res => {
        this.lists = res.data.data
        this.lists.publishedtime = formateDateNumber(this.lists.addTime)
        this.lists.detail = delEnter(this.lists.content)
      })
    },
    // 极之美合作活泼详情
    getjzmpartnerdetail (id) {
      getPartnersListDetail({id}).then(res => {
        this.lists = res.data.data
        this.lists.publishedtime = formateDateNumber(this.lists.addTime)
        this.lists.detail = delEnter(this.lists.content)
      })
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'changePage'
  },
  mounted () {
    if (this.$route.query.free) {
      this.navigate = ['首页', '自由行攻略']
      this.getfreedetail(this.$route.query.id)
      this.reviewdetail(this.$route.query.id)
    } else if (this.$route.query.id) {
      this.getreviewdetail(this.$route.query.id)
      this.reviewdetail(this.$route.query.id)
    } else if (this.$route.params.id) {
      this.getreviewdetail(this.$route.params.id)
      this.reviewdetail(this.$route.params.id)
    } else if (this.$route.query.newsId) {
      this.navigate = ['首页', '极之美资讯']
      this.getjzmdetail(this.$route.query.newsId)
      this.reviewdetail(this.$route.query.newsId)
    } else if (this.$route.params.newsId) {
      this.navigate = ['首页', '极之美资讯']
      this.getjzmdetail(this.$route.params.newsId)
      this.reviewdetail(this.$route.params.newsId)
    } else if (this.$route.params.partnerId) {
      this.navigate = ['首页', '极之美资讯']
      this.getjzmpartnerdetail(this.$route.params.partnerId)
      this.reviewdetail(this.$route.params.partnerId)
    }
    this.changePage()
    if (this.$route.params.img) {
      this.bkimg = this.$route.params.img
    }
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
    this.getthemelist()
  }
}
</script>
<style scoped>
  .main{
      background-color:#f4f4f4;
      padding-bottom:1.5rem;
  }
  .pointer{
    cursor: pointer;
  }
  .contain{
    width:80rem;
    margin: -200px auto 0;
  }
  .list-bg {
        width: 100%;
        height: 672px;
        background: url(../static/images/glxq.png) no-repeat center;
        background-size: cover;
    }
  .top {
    background-color: #fff;
    display:flex;
    padding-bottom: 30px;
  }
  .navigate{
    height:3.75rem;
    text-align:left;
    color:#0080cc;
    font-size:.875rem;
    line-height:3.75rem;
    padding-left:1.5rem;
    border-bottom:1px solid #dae1e6;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .navigate span{
    margin-left:.3125rem;
  }
  .lastnav{
    color:#60676d;
  }
  .left{
    width:121.5rem;
    border-right:1px solid #f4f4f4;
    background-color: #fff;
  }
  .right{
    padding:0 1.375rem;
    background-color: #fff;
  }
  .relate{
    font-size:1.125rem;
    margin-top: 1.25rem;
    color:#000
  }
  .relatecontentt{
    display:flex;
    padding-bottom:1.25rem;
    border-bottom:1px solid #f4f4f4;
    margin-top: 1.25rem;
  }
   .relatecontentt:nth-last-child(1){
    border-bottom:0px;
  }
  .relatecontentt img{
    width:8.75rem;
    height:5.625rem;
  }
  .title{
    font-size: 1rem;
    color:#585858;
    margin:0
  }
  .describe{
    font-size:.875rem;
    width:8.75rem;
    color:#9ca5ab;
    margin:.5rem 0 0.5rem 0;
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .price{
    font-size:.875rem;
    color:#ff9900;
  }
  .count{
    font-size: .75rem;
    color:#969fa6;
  }
  .priceitem{
    display:flex;
    align-items: center;
    justify-content: space-between;
  }
  .con{
    margin-left:.625rem;
    width:8.75rem;
  }
  .counttime{
    display:flex;
    align-items: center;
  }
  .content{
    margin:0 1.5rem;
  }
  .contentt{
    padding:1.875rem 1.5rem;
  }
  .ctitle{
    font-size: 1.5rem;
    color:#313131;
  }
  .counttime{
    display:flex;
    font-size: 14px;
    align-items: center;
    margin-top:1.25rem;
    color:#8d8d8d
  }
  .counttime img:nth-of-type(2){
    margin-left:1.25rem
  }
  .counttime span{
    margin-left:.375rem;
  }
  .detail{
    margin-top:2.375rem;
  }
  .detail p{
    text-indent:2em; padding:0px; margin:0px;
    font-size:.875rem;
    color:#585858;
    margin-top:1.875rem;
  }
  .detail img{
    width:100%;
    margin:0 0 1.25rem 0;
  }

  .boderright{
    border-right: 1px solid #585858;
  }
  .bottom{
    margin-top:1.5rem;
    padding:1.25rem 1.5rem;
    background-color: #fff;
  }
  .like{
    display:flex;
    align-items: center;
    justify-content: space-between;
  }
  .like p{
    font-size: 1.5rem;
    color:#3f464c;
  }
  .change span{
    font-size:.875rem;
    color:#7f8286;
    margin-right:.375rem;
  }
  .change img{
    width:.875rem;
    height:.875rem;
  }
  .likeline{
    position: relative;
    width:24.6875rem;
    margin-left:1.5rem;
  }
  .likeline:nth-of-type(1){
    margin-left:0;
  }
  .space{
    position:absolute;
    top:0;
    left:0;
    width:10.5rem;
    height:2.125rem;
    background-color: rgb(0,0,0,.5);
    color:#fff;
    font-size:.875rem;
    line-height: 2.125rem;
    padding-left: .875rem;
  }
  .line{
    color:#d3d3d3;
    margin:0 .75rem;
  }
  .flex{
    display:flex;
  }
  .align-items{
    align-items: center;
  }
  .justify-content{
    justify-content: space-between;
  }
  .routline{
    position: absolute;
    width:5.125rem;
    height:2rem;
    background-color: #ff7e00;
    color:#fff;
    line-height: 2rem;
    text-align: center;
    font-size:.875rem;
    left:0;
    top: 14.625rem;
  }
  .likepic{
    width:24.6875rem;
    height: 16.625rem;
  }
  .lines{
    font-size:.875rem;
    color:#ff9900;
    font-style:italic;
    margin-top:1rem;
  }
  .liketitle{
    font-size:1.125rem;
    color:#434343;
    margin-top:.625rem;
  }
  .liketime{
    font-size:.875rem;
    color:#7a7a7a;
    margin-top: .625rem
  }
  .labels{
    font-size:.75rem;
    color:#3399ff;
    border:1px solid #3399ff;
    text-align:center;
    margin-top:1.25rem;
    width:auto;
    height:1.5rem;
    margin-right:.625rem;
    line-height: 1.5rem;
    padding:0 .625rem;
  }
  .detail p img{
    width:100% ;
    height:auto ;
  }
  .rightcontent{
    margin-top: 19px;
  }
</style>



// WEBPACK FOOTER //
// src/views/pastReviewDetail.vue